export class Document {
    public id: string;
    public name: string;
    public description: string;
    public type: string;
    public required: boolean;
    public preWorkCard: boolean;
    public createdAt: string;
    public mimeTypes: string[];
    public updatedAt: string;
    public file?: any;
    public jkp: boolean;
    public government: boolean;
    public private: boolean;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/document.ts